module.exports = __webpack_public_path__ + "static/media/SRPB77_01.089523a7.png";